import moment from 'moment';
import ModuleConfig from './Config';

const actions = ModuleConfig.Actions;

const initialState = {
    data: [],
    count: 0,
    page: 1,
    pageCount: 1,
    pageSize: 20,
    search: '',
    current: {},
    errors: {},
    syncProgress: null,
    isSyncing: false,
    updated: moment().format('YYYYMMDDHHmmss')
};

export default function catalog(state = initialState, action) {
    switch (action.type) {
        case actions.getAll.success.id:
            return Object.assign({}, state, {
                data: action.options.data,
                count: action.options.count,
                pageSize: action.options.pageSize,
                page: action.options.page,
                pageCount: action.options.pageCount,
                search: action.options.search,
                updated: moment().format('YYYYMMDDHHmmss')
            });
        case actions.getOne.success.id:
            return Object.assign({}, state, {
                current: action.options,
                errors: {}
            });
        case actions.syncHeo.request.id:
            return Object.assign({}, state, {
                isSyncing: true,
                syncProgress: null
            });
        case actions.syncHeo.success.id:
            return Object.assign({}, state, {
                isSyncing: false,
                syncProgress: action.options
            });
        case actions.syncHeo.failure.id:
            return Object.assign({}, state, {
                isSyncing: false,
                syncProgress: { type: 'error', message: action.options }
            });
        default:
            return state;
    }
}
